import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  styled,
  TextField,
  FormHelperText,
  Stack,
  MenuItem,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import BannerImage from "../../component/admin/professionalTournaments/BannerImage";
import GoalVideoUpload from "../../component/admin/professionalTournaments/GoalVideoUpload";
import { addProfessionalTournament } from "../../api/addProfessionalTournament";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ProfessionalTournamentForm from "../../component/admin/formComponents/ProfessionalTournamentForm";
import { getProfessionalTournament } from "../../api/getProfessionalTournament";
import { updateProfessionalTournament } from "../../api/updateProfessionalTournament";
import { generateRandomNumber } from "../../helper/generateRandom";

const EditProfessionalTournament = () => {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [deletedVideos, setDeletedVideos] = useState([]);
  const [editTableVideos, setEditableVideos] = useState([]);
  const [goalVideos, setGoalVideos] = useState([]);

  const [errorState, setErrorState] = useState("");
  const [formErrors, setFormErrors] = useState(false);
  const fetchProfessionalTournamentData = async (id, token) => {
    try {
      setLoading(true);

      const data = await getProfessionalTournament(id, token);
      if (data.success) {
        formik.setValues({
          title: data.data.title,
          description: data.data.description,
          yt_link: data.data.yt_link,
          //   category: data.tournament.type,
          image: data.data.banner_img,
          video: data.data.professionalTournamentGoals.map(
            (data) => data.video
          ),
          YTVideo: data.data.yt_video,
          category: data.data.type,
        });
        setEditableVideos(
          data.data.professionalTournamentGoals.map((data) => ({
            video: data.video,
            id: data.id,
          }))
        );
        setGoalVideos(() => {
          return data.data.professionalTournamentGoals.map((goal) => ({
            goal: goal.video,
            goal_image: goal.goal_image, // <-- ADD THIS
            id: goal.id,
            club_name: goal.club_name,
            goal_scorer: goal.goal_scorer,
            edited: false,
            checked: true,
            validated: true,
            key_Id: generateRandomNumber(5),
          }));
        });
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error fetching tournament data:", error);
      toast.error("Failed to fetch tournament data");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (id) {
      fetchProfessionalTournamentData(id, token);
    } else {
      setLoading(false);
      toast.error("Tournament ID is missing");
      navigate("/admin/dashboard/international-tournament");
    }
  }, [id, token]);

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      yt_link: "",
      category: 1,
      image: "",
      // video: [],
      YTVideo: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      description: Yup.string().required("Description is required"),
      yt_link: Yup.string(),
      // category: Yup.number().required("Category is required"),
      image: Yup.mixed().required("Banner Image is required"),
    }),
    validateOnChange: true,
    onSubmit: async (values) => {

      let error = false;

      goalVideos.map((prev, index) => {
        if (
          prev.checked &&
          prev.goal_scorer.trim() !== "" &&
          prev.club_name.trim() !== ""
        ) {
          return prev;
        } else {
          error = true;
          return { ...prev, error: "Please add the goal video" };
        }
      });

      if (error) {
        setErrorState("Please add the goal videos");
        // toast.error("Please add the goal videos");
        return;
      } else {
        setErrorState("");
      }

      const editedVideo = goalVideos.filter((v) => {
        // "";
        return v.edited && !v.created;
      });
      const newVideo = goalVideos.filter((v) => v.created);

      // const deletedVideo = [];

      const video = newVideo.map((v) => v.goal);
      const video_meta = newVideo.map((v) => ({
        club_name: v.club_name,
        goal_scorer: v.goal_scorer,
      }));

      const edited = editedVideo.map((v) => ({
        club_name: v.club_name,
        goal_scorer: v.goal_scorer,
        id: v.id,
        hasNewImage: v.goal_image instanceof File,
      }));
     

      const data = {
        title: values.title,
        type: values.category,
        video,
        description: values.description,
        yt_link: values.yt_link,
        image: values.image,
        deletedVideos,
        YTVideo: values.YTVideo,
        video_meta,
        edited_videos: edited,
        goalVideos, // ADD THIS
      };

      data.id = id;
      data.type = 1;

      try {
        setLoading(true);
        let resdata = await updateProfessionalTournament(data, token);

        if (resdata.success) {
          toast.success(resdata.message);
          setTimeout(() => {
            navigate("/admin/dashboard/international-tournament");
          }, 1000);
        } else {
          toast.error(resdata.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="page_title tournament_title">
        <Typography variant="h1" component="h1">
          Edit International Tournaments
        </Typography>

        {/* <DeleteOutlineIcon className="delete-icon" /> */}
      </Box>

      <ProfessionalTournamentForm
        formik={formik}
        edited={true}
        // editTableVideos={editTableVideos}
        setDeletedVideos={setDeletedVideos}
        goalVideos={goalVideos}
        setGoalVideos={setGoalVideos}
        setFormErrors={setFormErrors}
      />
      {errorState && (
        <FormHelperText sx={{ color: "red" }}>{errorState}</FormHelperText>
      )}
    </>
  );
};

export default EditProfessionalTournament;
